import { createStorageAtomFactory, withSerialization } from '@exodus/atoms'
import { OrderSet } from '@exodus/models'

const defaultValue = OrderSet.EMPTY

const createOrdersAtom = ({ storage }) => {
  const deserialize = (ordersArr) => OrderSet.fromArray(ordersArr)

  const serialize = (orderSet) => orderSet?.toJSON()

  const atom = createStorageAtomFactory({ storage })({
    key: 'orders',
    defaultValue: serialize(defaultValue),
    isSoleWriter: true,
  })

  return withSerialization({ atom, serialize, deserialize })
}

export default createOrdersAtom
